<template>
  <div class="product-list">
    <video autoplay muted loop playsinline class="video-bg">
      <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4">
    </video>
    <div class="overlay">
      <h1>{{ $t('title') }}</h1>
      <div class="products">
        <el-card class="product-card" v-for="item in products" :key="item.name">
          <img :src="item.image" class="product-image" />
          <div>{{ item.name }}</div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      products: [
        { name: this.$t('ddr4'), image: require('../assets/logo.png') },
        { name: this.$t('ddr5'), image: require('../assets/logo.png') },
        { name: this.$t('laptop'), image: require('../assets/logo.png') },
        { name: this.$t('rgb'), image: require('../assets/logo.png') }
      ]
    };
  }
}
</script>

<style scoped>
.product-list {
  position: relative;
  overflow: hidden;
}
.video-bg {
  width: 100%;
  height: auto;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: white;
}
.products {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.product-card {
  width: 200px;
  margin: 10px;
}
.product-image {
  width: 100%;
}
</style>
